<template>
  <div class="shipping-address">
    <div class="page-header">
      <div class="page-title" style="cursor: pointer" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        {{ $t("message.home.shippingAddress") }}
      </div>
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click="addAddressHandle"
        >{{ $t("message.home.addNewAddress") }}</el-button
      >
    </div>
    <div class="page-content" v-loading="loading">
      <div v-if="objsList.length" class="address_list">
        <div class="item" v-for="item in objsList" :key="item.id">
          <div class="info">
            <div class="name-and-mobile">
              <span class="name">{{ item.consignee }}</span>
              <span class="mobile">&nbsp;&nbsp;+{{ item.phone }}</span>
            </div>
            <el-switch
              :value="item.isDefault"
              :active-value="true"
              :inactive-value="false"
            />
            <!-- @change="setAddressDefalut($event, item)" -->
            <el-popover placement="bottom" width="250" trigger="click" ref="addressPup">
              <i class="el-icon-more" slot="reference"></i>
              <ul class="address-menu">
                <li @click="editAddrss(item)">{{ $t("message.home.edit") }}</li>
                <!-- <li @click="setAddressDefalut(1, item)">
                  {{ $t("message.home.markDefaultAddress") }}
                </li> -->
                <li @click="address_delete(item.id)">
                  {{ $t("message.home.delete") }}
                </li>
              </ul>
            </el-popover>
          </div>
          <!-- {{ item.country }} {{ item.province }} {{ item.city }} -->
          <div class="address">
            {{ item.regionName }}{{ item.address }}
            <!-- {{ item.country }} {{ item.province }} {{ item.city }}
            {{ item.address }} -->
          </div>
        </div>
      </div>
      <el-empty
        v-if="!addressList.length && !loading"
        :description="$t('message.home.noData')"
      ></el-empty>
    </div>

    <EsAddressDialog
      v-model="addAdressDialogVisible"
      :addressItemData="currentAddressInfo"
      :isEdit="isAddressEdit"
      :prov="prov"
      :itemCity="itemCity"
      :key="Math.random()"
      @parent-refresh="address_list"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EsAddressDialog from "@/components/addAddress";
//////////////////////////////////////////////////////////////////////////////////////////////////

import {
		list,
		add,
		save,
		edit,
		update,
		del,
	} from "@/api/upms/address.js"

//////////////////////////////////////////////////////////////////////////////////////////////////
export default {
  name: "EsAddress",
  components: { EsAddressDialog },
  data() {
    return {
      loading: true,
      addAdressDialogVisible: false,
      currentAddressInfo: null,
      isAddressEdit: false,
      prov: "",
      itemCity: "",
//////////////////////////////////////////////////////////////////////////////////////////////////

        currentPage: 1,
				// 设置加载的第几次，默认是第一次  
				pageSize: 10,
				//返回数据的个数  
				orderBy: "",
				//排序字段
				orderType: "",
				//排序 asc正 desc反
				searchLoading: false,
				//"上拉加载"的变量，默认false，隐藏  
				searchLoadingComplete: false,
				//“没有数据”的变量，默认false，隐藏 

				shengArr: [],
				//省级数组
				shengId: [],
				//省级id数组
				shiArr: [],
				//城市数组
				shiId: [],
				//城市id数组
				quArr: [],
				//区数组
				objsData: [],
				shengIndex: 0,
				shiIndex: 0,
				quIndex: 0,
				mid: 0,
				sheng: 0,
				city: 0,
				region: 0,
				code: 0,
				cartId: 0,
				current: -1,
				addressId: "",
				objsList: [],
				loadType: 'load',
				queryParams: {
					pageNumber: 1,
					pageSize: 10,
				},
				selectFlag:false

//////////////////////////////////////////////////////////////////////////////////////////////////
    };
  },
  computed: {
    ...mapGetters("user", ["addressList"]),
  },
  methods: {
    ...mapActions("user", [
      "requestAddressList",
      "requestAddressEdit",
      "requestAddressAdd",
      "requestAddressDel",
    ]),
    async setAddressDefalut(value, item) {
      try {
        this.loading = true;
        item.contacts = encodeURIComponent(item.contacts);
        await this.requestAddressEdit({
          ...item,
          ...{ use: value },
        });
      } finally {
        this.$refs.addressPup.forEach((item) => {
          item.showPopper = false;
        });
        this.loading = false;
      }
    },
    async delAddress(item) {
      try {
        this.loading = true;
        // await this.requestAddressDel({ id: item.id });




      } finally {
        this.loading = false;
      }
    },
    editAddrss(item) {
      this.isAddressEdit = true;
      this.addAdressDialogVisible = true;
      this.prov = item.province || '';
      this.itemCity = item.city || '';
      this.currentAddressInfo = { ...item };
    },
    addAddressHandle() {
      this.prov = ''
      this.itemCity = ''
      this.isAddressEdit = false;
      this.addAdressDialogVisible = true;
      this.currentAddressInfo = null;
    },
    goBack() {
      this.$router.push("/userInfo/setup");
    },
  
//////////////////////////////////////////////////////////////////////////////////////////////////

      radioChange: function(evt) {
				for (let i = 0; i < this.objsData.length; i++) {
					if (this.objsData[i].id == evt.detail.value) {
						this.current = i;
						this.addressId = this.objsData[i].id;
						this.addressChecked();
					}
				}
			},
			
			/**
			 * 查询列表 list
			 */
			address_selected(item) {
				if(this.selectFlag){					
					uni.$emit('addressLoadSuccess',item);
					uni.navigateBack();
				}
				
        this.loading=true;
				// list(this.queryParams).then(response => {
				// 	//下拉加载
				// 	if (this.loadType === "reach") {
				// 		const newObjsList = response.data.data.content;
				// 		newObjsList.forEach(item => this.objsList.push(item));
				// 		this.searchLoading = false;
				// 		//加载
				// 	} else if (this.loadType === "load") {
				// 		this.objsList = response.data.data.content;
				// 		//下拉刷新
				// 	} else if (this.loadType === "pullDown") {
				// 		uni.stopPullDownRefresh();
				// 	}
				// });
				// uni.$emit('addressLoadSuccess',"ok");
			},

			/**
			 * 查询列表 list
			 */
			address_list() {
        this.loading=true;
				list(this.queryParams).then(response => {

          this.loading = false;

					//下拉加载
					// if (this.loadType === "reach") {
					// 	const newObjsList = response.data.data.content;
					// 	newObjsList.forEach(item => this.objsList.push(item));
					// 	this.searchLoading = false;
					// 	//加载
					// } else if (this.loadType === "load") {
						this.objsList = response.data.data.content;
						//下拉刷新
					// } else if (this.loadType === "pullDown") {
					// 	uni.stopPullDownRefresh();
					// }
					// if(!this.objsList || 0==this.objsList.length){
					// 	uni.$emit('addressLoadSuccess',null);
					// }
					// if(this.objsList && 1==this.objsList.length){
					// 	uni.$emit('addressLoadSuccess',this.objsList[0]);
					// }
					
				});
				// uni.$emit('addressLoadSuccess',"ok");
			},

			address_delete: function(id) {
        
        this.loading=true;
				del({
					'id': id
				}).then(response => {
          this.loading = false;
          this.$message({
              type: "success",
              message: this.$t("message.home.operationSuccess"),
          });
          this.address_list();
          this.loading=false;
					// uni.showToast({
					// 	title: this.messages['common_deleteSuccess'],
					// 	icon: 'loading',
					// 	duration: 1500
					// });
					// let that=this;
					// setTimeout(function() {	
					// 	that.loadType = "load";
					// 	that.queryParams.pageNumber = 1;
					// 	that.address_list();
					// }, 2000);
				}).catch(error => {
          this.loading=false;
					// uni.showToast({
					// 	title: this.messages['common_message_unknownError'],
					// 	duration: 2000
					// });
				})
			},

//////////////////////////////////////////////////////////////////////////////////////////////////
  },
  async mounted() {
    try {
      this.loading = true;
      // await this.requestAddressList();

      this.address_list();

    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
html[dir='rtl']{
  .shipping-address .address_list > .item{
    float: right;
    margin-right: 0;
    margin-left: 22px;
  }
}
.shipping-address {
  .page-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .page-content {
    min-height: 270px;
  }
  .address_list {
    margin-top: 20px;
    overflow: hidden;
    > .item {
      width: 270px;
      height: 110px;
      padding: 20px 10px;
      font-size: 12px;
      float: left;
      border: 1px solid var(--color-border);
      margin-right: 22px;
      margin-bottom: 20px;
      border-radius: 4px;
      &:nth-child(3n) {
        margin-right: 0;
      }

      > img {
        width: 60px;
        height: 60px;
      }

      > .info {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .name-and-mobile {
          flex: 1;
          font-weight: 400;
          color: var(--color-title);
          span {
            display: inline-block;
            max-width: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .el-icon-more {
          font-size: 14px;
          color: var(--color-subtitle);
          margin-left: 10px;
          transform: rotate(90deg);
          cursor: pointer;
        }
      }

      > .address {
        color: var(--color-subtitle);
        font-weight: 500;
        margin-top: 5px;
        width: 100%;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.address-menu {
  > li {
    padding: 8px 10px;
    font-size: 12px;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
